module.exports = __webpack_public_path__ + "img/statistic-screen-1.c2d0dfa.jpg";